/**
 * Action types for pages module
 */
export const FETCH_PAGE = 'pages/FETCH_PAGE';
export const FETCH_PAGE_SUCCESS = 'pages/FETCH_PAGE_SUCCESS';
export const FETCH_PAGES = 'pages/FETCH_PAGES';
export const CLEAR_PAGES = 'pages/CLEAR_PAGES';
export const FETCH_PAGES_SUCCESS = 'pages/FETCH_PAGES_SUCCESS';
export const SAVE_PAGE = 'pages/SAVE_PAGE';
export const SAVE_PAGE_SUCCESS = 'pages/SAVE_PAGE_SUCCESS';
export const UPDATE_PAGE_SORT_ORDER = 'pages/UPDATE_PAGE_SORT_ORDER';
export const UPDATE_PAGE_SORT_ORDER_SUCCESS =
  'pages/UPDATE_PAGE_SORT_ORDER_SUCCESS';
export const UPDATE_PAGE = 'pages/UPDATE_PAGE';
export const UPDATE_PAGE_SUCCESS = 'pages/UPDATE_PAGE_SUCCESS';
export const DELETE_PAGE = 'pages/DELETE_PAGE';
export const DELETE_PAGE_SUCCESS = 'pages/DELETE_PAGE_SUCCESS';
export const SOFT_DELETE_PAGE = 'pages/SOFT_DELETE_PAGE';
export const SOFT_DELETE_PAGE_SUCCESS = 'pages/SOFT_DELETE_PAGE_SUCCESS';
